import { TIPTAP_EMBED_TYPE, TIPTAP_LINK_PREVIEW_TYPE } from "./../../ricos-content";
import { convertBlockDataToRicos } from "./../../ricos-content/lib/convertBlockDataToRicos";
import {
  createRicosFunctionalExtension,
  createRicosNodeExtension
} from "./../../plugin-commons";
import {
  createLinkPreviewData,
  fetchLinkPreview,
  shouldAddEmbed,
  shouldAddLinkPreview
} from "../lib/utils";
import { LINK_PREVIEW_TYPE } from "../types";
import { Embed } from "./embed";
import { LinkPreview } from "./link-preview";
const urlRegex = (
  // eslint-disable-next-line max-len
  /(?:https?:\/\/)?(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z]{2,}\b(?:[-a-zA-Z0-9@:%._+~#=?!&/]*)(?:[-a-zA-Z0-9@:%._+~#=?!&/]*)/gi
);
const urlRegexExact = new RegExp("^" + urlRegex.source + "$", "gi");
const isLinkOnlyBlock = ({ parent, nodeBefore }) => parent.childCount === 1 && nodeBefore?.text?.search(urlRegexExact) !== -1;
const addLinkPreview = (config) => ({ editor }) => {
  const pos = editor.state.selection.$anchor;
  const {
    enableEmbed = true,
    enableLinkPreview = true,
    fetchData,
    link: linkConfig
  } = config || {};
  if (pos.nodeBefore?.text && isLinkOnlyBlock(pos) && fetchData && (enableEmbed || enableLinkPreview)) {
    let isPreviewAdded = false;
    const { target, rel } = linkConfig || {};
    const url = pos.nodeBefore?.text;
    fetchLinkPreview(fetchData, url).then((linkPreviewData) => {
      const shouldEmbed = shouldAddEmbed(
        linkPreviewData.html,
        enableEmbed,
        linkPreviewData.fixedUrl
      );
      if (shouldEmbed || shouldAddLinkPreview(linkPreviewData.title, enableLinkPreview)) {
        isPreviewAdded = true;
        return createLinkPreviewData({ url, target, rel }, linkPreviewData, config).then(
          (linkPreviewComponentData) => {
            const convertedLinkPreviewData = convertBlockDataToRicos(
              LINK_PREVIEW_TYPE,
              linkPreviewComponentData
            );
            editor.chain().focus().deleteRange({ from: pos.pos - (pos.nodeBefore?.nodeSize || 0), to: pos.pos }).insertContent([
              {
                type: shouldEmbed ? TIPTAP_EMBED_TYPE : TIPTAP_LINK_PREVIEW_TYPE,
                attrs: convertedLinkPreviewData
              },
              { type: "PARAGRAPH" }
            ]).run();
          }
        );
      }
    }).finally(() => {
    });
    return isPreviewAdded;
  }
  return false;
};
const tiptapExtensions = [
  createRicosNodeExtension({
    name: TIPTAP_LINK_PREVIEW_TYPE,
    groups: ["overlay", "draggable", "not-overtypable"],
    type: "react-node",
    reconfigure: (config, _extensions, _props, settings) => ({
      ...config,
      addOptions: () => settings
    }),
    Component: LinkPreview,
    createExtensionConfig() {
      return {
        group: "block layoutCellContent collapsibleListItemBodyContent tableCellContent",
        selectable: true,
        draggable: true,
        name: this.name,
        addAttributes: () => ({
          containerData: null,
          link: null,
          title: null,
          thumbnailUrl: null,
          description: null,
          html: null
        }),
        addCommands() {
          return {
            setLinkPreview: (attributes) => ({ commands }) => {
              return commands.setNode("linkPreview", attributes);
            }
          };
        }
      };
    }
  }),
  createRicosNodeExtension({
    name: TIPTAP_EMBED_TYPE,
    groups: ["overlay", "draggable", "not-overtypable"],
    type: "react-node",
    reconfigure: (config, _extensions, _props, settings) => ({
      ...config,
      addOptions: () => settings
    }),
    Component: Embed,
    createExtensionConfig() {
      return {
        group: "block layoutCellContent collapsibleListItemBodyContent tableCellContent",
        selectable: true,
        draggable: true,
        name: this.name,
        addAttributes: () => ({
          containerData: null,
          oembed: null,
          src: null
        })
      };
    }
  }),
  createRicosFunctionalExtension({
    type: "extension",
    groups: ["shortcuts-enabled"],
    name: "linkPreviewEnter",
    reconfigure: (config, _extensions, _props, settings, services) => ({
      ...config,
      addKeyboardShortcuts() {
        const newLine = addLinkPreview(settings);
        const tiptapKeyboardShortcuts = {
          Enter: newLine
        };
        const newLineShortcuts = [];
        services.shortcuts.shortcuts.forEach((shortcut) => {
          if (shortcut.shortcut.name === "NewLine") {
            newLineShortcuts.push(shortcut);
          }
        });
        newLineShortcuts.forEach((newLineShortcut) => {
          const modifier = newLineShortcut.keys.macOs.modifiers[0];
          const key = newLineShortcut.keys.macOs.key;
          const shortcutKey = modifier ? `${modifier}-${key}` : key;
          tiptapKeyboardShortcuts[shortcutKey] = newLine;
        });
        return {
          ...tiptapKeyboardShortcuts
        };
      }
    }),
    createExtensionConfig() {
      return {
        name: this.name,
        priority: 101
      };
    }
  })
];
export {
  tiptapExtensions
};
//# sourceMappingURL=tiptap.js.map
